"use client";

import { cn } from "@/lib/utils";
import { Lock, CheckCircle2 } from "lucide-react";


interface TrustSignalsProps {
  variant?: "default" | "minimal";
  className?: string;
}

export function TrustSignals({ variant = "default", className }: TrustSignalsProps) {
  if (variant === "minimal") {
    return (
      <div
        className={cn("flex items-center justify-center animate-reveal-in", className)}
        style={{ animationDelay: "200ms" }}
      >
        <Lock className="size-3.5 text-muted-foreground/50" strokeWidth={2} aria-hidden="true" />
      </div>
    );
  }

  return (
    <div
      className={cn("flex items-center justify-center gap-4 text-sm animate-reveal-in", className)}
      style={{ animationDelay: "150ms" }}
    >
      <TrustItem delay={100}>5-day free trial</TrustItem>
      <span className="text-white/10">|</span>
      <TrustItem delay={200}>Cancel anytime</TrustItem>
    </div>
  );
}

function TrustItem({ children, delay = 0 }: { children: React.ReactNode; delay?: number }) {
  return (
    <span
      className="inline-flex items-center gap-1.5 text-muted-foreground animate-reveal-in"
      style={{ animationDelay: `${delay}ms` }}
    >
      <span className="relative flex items-center justify-center">
        <span
          className="absolute size-4 rounded-full blur-sm"
          style={{ background: "hsl(190 100% 50% / 0.25)" }}
        />
        <CheckCircle2
          className="relative size-3.5 text-primary"
          strokeWidth={2.5}
          aria-hidden="true"
        />
      </span>
      <span>{children}</span>
    </span>
  );
}
